export const SHOW_FEEDBACK_INIT = 'SHOW_FEEDBACK_INIT'
export const SHOW_FEEDBACK_FINISH = 'SHOW_FEEDBACK_FINISH'
